module.exports = __webpack_public_path__ + "ff26dc3447babacead1abbab18c3e7c4.svg";